import { useEffect, useState } from "react";
import { Button, Form, Input, Select, Switch } from "antd";
import classes from "./MakeBooking.module.scss";

import { useSelector } from "react-redux";
import TimeSlotModal from "./modals/TimeSlotModal";
import { startPatternRule, validateMessages } from "../utils/validation";

export default function MakeBooking({
  cargoTypeOptions,
  vehicleOptions,
  driverOptions,
  deliveryZoneOptions,
}) {
  const [isTimeSlotModalOpen, setIsTimeSlotModalOpen] = useState();
  const [formValues, setFormValues] = useState({});
  const [form] = Form.useForm();

  const toggleTimeSlotModal = (booked) => {
    if (booked) {
      setIsTimeSlotModalOpen(false);
      form.resetFields();
    } else {
      setIsTimeSlotModalOpen((prev) => !prev);
    }
  };

  const selectedDeliveryZone =
    Form.useWatch((values) => values.deliveryZone, form) || "GREEN";

  const isCargoMilkRun = Form.useWatch(
    (values) =>
      values.cargoType === "WASTE_COLLECTION" || values.cargoType === "F_AND_B",
    form
  );
  const isMilkRunSelected = Form.useWatch((values) => values.milkrun, form);
  const cargoType = Form.useWatch("cargoType", form);
  const milkrunPermission = useSelector((state) => state.user.user.milkrun);

  useEffect(() => {
    if (isMilkRunSelected !== undefined)
      form.setFieldsValue({ deliveryZone: undefined });
    if (!isCargoMilkRun) {
      form.setFieldsValue({ milkrun: undefined });
    }
  }, [isMilkRunSelected, isCargoMilkRun, form]);

  const handleSubmit = (values) => {
    setFormValues(values);
    toggleTimeSlotModal();
  };

  return (
    <div className={classes.container}>
      <h1>Make a booking</h1>
      <main>
        <Form
          name="bookingForm"
          form={form}
          onFinish={handleSubmit}
          labelCol={{ flex: "180px" }}
          labelAlign="left"
          autoComplete="off"
          validateMessages={validateMessages}
        >
          <Form.Item
            name="cargoType"
            label="Cargo Type"
            rules={[{ required: "true" }]}
          >
            <Select
              placeholder="Select cargo type"
              options={cargoTypeOptions}
            />
          </Form.Item>

          {cargoType === "OTHERS" && (
            <Form.Item
              name="cargoTypeDescription"
              label="Cargo Type Description"
              rules={[
                {
                  required: true,
                  min: 4,
                  max: 20,
                },
                startPatternRule,
              ]}
            >
              <Input placeholder="Enter cargo type" />
            </Form.Item>
          )}

          <Form.Item
            name="vehicleId"
            label="Vehicle"
            rules={[{ required: "true" }]}
          >
            <Select placeholder="Select vehicle" options={vehicleOptions} />
          </Form.Item>

          <Form.Item
            name="driverId"
            label="Driver"
            rules={[{ required: "true" }]}
          >
            <Select placeholder="Select driver" options={driverOptions} />
          </Form.Item>

          {isCargoMilkRun && milkrunPermission && (
            <Form.Item name="milkrun" label="Milk Run" valuePropName="checked">
              <Switch />
            </Form.Item>
          )}

          <Form.Item
            name="deliveryZone"
            label="Delivery Zone"
            rules={[{ required: "true" }]}
            value={isMilkRunSelected ? [] : []}
          >
            <Select
              placeholder="Select delivery zone"
              options={
                isMilkRunSelected
                  ? deliveryZoneOptions.forMilkRun
                  : deliveryZoneOptions.regular
              }
            />
          </Form.Item>

          <div className={classes.timeSlotInputWrapper}>
            <Form.Item
              label="Time Slot"
              className={classes.submitButton}
              style={{ width: "100%" }}
            >
              <Button className="ant-btn-secondary" htmlType="submit">
                Select time slot and continue
              </Button>
            </Form.Item>
          </div>
        </Form>
        <TimeSlotModal
          open={isTimeSlotModalOpen}
          onClose={toggleTimeSlotModal}
          formValues={formValues}
          zone={selectedDeliveryZone}
        />
      </main>
    </div>
  );
}
